'use strict';

/**
 * リンク形式に変換された User Mention を抽出するための正規表現を返す
 */
const matcher = function() {
    // var baseUrl = Balus.app.url;
    return new RegExp('/users/(\\w+)$');
    // return new RegExp('^(?:__URL__)/users/(\\w+)$'.replace(/__URL__/, baseUrl));
};

class Mention {
    /**
     * リンク形式に変換された User の Mention に対して click された場合に
     * 対象の User を選択状態にする Handler を付加する。
     */
    addClickHandler($el) {
        $el.find('a').each(function(i, el) {
            const $e = $(el);
            const m = $e.attr('href') ? $e.attr('href').match(matcher) : null;
            if (m) {
                const id = m[1];
                // TODO: ユーザがグループ内に見つからない時の処理を追加

                $e.click(function(e) {
                    e.preventDefault();
                    Balus.notify.info({
                        title: 'ユーザ: ' + id + 'が選択されました'
                    });
                });
            }
        });
    };

    /**
     * リンク形式の User Mention のID一覧を返す
     */
    fetchMentionData($el) {
        let results = [];

        $el.find('a').each(function(i, el) {
            const $e = $(el);
            const m = $e.attr('href') ? $e.attr('href').match(matcher()) : null;
            if (m) {
                const id = m[1];
                // TODO: ユーザがグループ内に見つからない時の処理を追加
                results.push(id);
            }
        });

        return results;
    };
};

module.exports = Mention;



// WEBPACK FOOTER //
// ./common/util/user-mention.js